import { render, staticRenderFns } from "./BrowserMessages.vue?vue&type=template&id=228e0502&"
import script from "./BrowserMessages.vue?vue&type=script&lang=js&"
export * from "./BrowserMessages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports